import { render, staticRenderFns } from "./TestResultCard.vue?vue&type=template&id=c2d048e0"
import script from "./TestResultCard.vue?vue&type=script&lang=js"
export * from "./TestResultCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports